import { render, staticRenderFns } from "./TitleWithPenSwitcher.vue?vue&type=template&id=45d2021a&scoped=true&lang=pug&"
import script from "./TitleWithPenSwitcher.vue?vue&type=script&lang=ts&"
export * from "./TitleWithPenSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./TitleWithPenSwitcher.vue?vue&type=style&index=0&id=45d2021a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2021a",
  null
  
)

export default component.exports